import { makeAwsSignedRequest } from '../ApiService';

export interface PendingDeltaEntry {
    label: string;
    startCount: number;
    endCount: number;
    absoluteChange: number;
    netNewCount: number;
    netRecoveredCount: number;
    netNewSampleRefundIds: string[];
    netRecoveredSampleRefundIds: string[];
}

export interface PendingDeltaResponse {
    generatedAt: string;
    timeWindow: string;
    clientId: string;
    requestedWindowStart?: string | null;
    requestedWindowEnd?: string | null;
    processorWindowStart?: string | null;
    processorWindowEnd?: string | null;
    clientWindowStart?: string | null;
    clientWindowEnd?: string | null;
    processorSnapshotsAnalyzed: number;
    clientSnapshotsAnalyzed: number;
    processors: PendingDeltaEntry[];
    clients: PendingDeltaEntry[];
}

export const PendingDeltaApi = {
    getPendingDeltas: (
        stage: string,
        realm: string,
        timeWindow: string,
        clientId: string,
        startTime?: string,
        endTime?: string,
    ): Promise<PendingDeltaResponse> => {
        const params = new URLSearchParams({ timeWindow, clientId });
        if (startTime) {
            params.set('startTime', startTime);
        }
        if (endTime) {
            params.set('endTime', endTime);
        }
        return makeAwsSignedRequest(stage, realm, `tracker/pending-deltas?${params.toString()}`);
    },
};
